/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mushy_Dry_Otter_TearInputs */

const en_mushy_dry_otter_tear = /** @type {(inputs: Mushy_Dry_Otter_TearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select date...`)
};

const de_mushy_dry_otter_tear = /** @type {(inputs: Mushy_Dry_Otter_TearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum auswählen...`)
};

/**
* | output |
* | --- |
* | "Select date..." |
*
* @param {Mushy_Dry_Otter_TearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mushy_dry_otter_tear = /** @type {((inputs?: Mushy_Dry_Otter_TearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mushy_Dry_Otter_TearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mushy_dry_otter_tear(inputs)
	return de_mushy_dry_otter_tear(inputs)
});